let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6ssx")).then(() => parcelRequire('ejhdy'));